<h2 mat-dialog-title>Account Session Info</h2>

<mat-dialog-content>
    <div class="session-info-container">
        <div class="info-section">
            <h3>Basic Information</h3>
            <div class="info-row">
                <span class="label">Name:</span>
                <span class="value">{{ data.account.name }}</span>
            </div>
            <div class="info-row">
                <span class="label">Email:</span>
                <span class="value">{{ data.account.login_info_email }}</span>
            </div>
            <div class="info-row">
                <span class="label">Type:</span>
                <span class="value">{{ data.account.type }}</span>
            </div>
            <div class="info-row">
                <span class="label">Session ID:</span>
                <span class="value copyable" (click)="copyToClipboard(data.account.id)">
                    {{ data.account.id }}
                    <mat-icon>content_copy</mat-icon>
                </span>
            </div>
            <div class="info-row">
                <span class="label">SID:</span>
                <span class="value copyable" (click)="copyToClipboard(data.account.sid)">
                    {{ data.account.sid }}
                    <mat-icon>content_copy</mat-icon>
                </span>
            </div>
            <div class="info-row">
                <span class="label">Proxy:</span>
                <span class="value">
                    {{ data.account.proxy }}
                </span>
            </div>
        </div>

        <div class="info-section">
            <h3>Status</h3>
            <div class="info-row">
                <span class="label">Status:</span>
                <span class="value status-badge" [ngClass]="'status-' + data.account.status">
                    {{ data.account.status }}
                </span>
            </div>
            <div class="info-row">
                <span class="label">Current Page:</span>
                <span class="value">{{ data.account.page || 'N/A' }}</span>
            </div>
            <div class="info-row">
                <span class="label">Message:</span>
                <span class="value">{{ data.account.message || 'N/A' }}</span>
            </div>
            @if (data.account.error_message) {
            <div class="info-row error-row">
                <span class="label">Error:</span>
                <span class="value error-text">{{ data.account.error_message }}</span>
            </div>
            }
        </div>

        <div class="info-section">
            <h3>Credit Information</h3>
            <div class="info-row">
                <span class="label" style="font-weight: bold;">Transferred:</span>
                <span class="value" style="font-weight: bold;">
                    {{
                    (data.account.current_credit != null && data.account.start_credit != null) ?
                    ((data.account.current_credit - data.account.start_credit) | number) :
                    'N/A'
                    }}
                </span>
            </div>
            <div class="info-row">
                <span class="label">Current Credit:</span>
                <span class="value">{{ data.account.current_credit !== null ? (data.account.current_credit | number) : 'N/A' }}</span>
            </div>
            <div class="info-row">
                <span class="label">Start Credit:</span>
                <span class="value">{{ data.account.start_credit !== null ? (data.account.start_credit | number) : 'N/A'
                    }}</span>
            </div>
        </div>

        <div class="info-section">
            <h3>Timestamps</h3>
            <div class="info-row">
                <span class="label">Created At:</span>
                <span class="value">{{ getFormattedDate(data.account.created_at) }}</span>
            </div>
            <div class="info-row">
                <span class="label">Updated At:</span>
                <span class="value">{{ getFormattedDate(data.account.updated_at) }}</span>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="close()">
        Close
    </button>
</mat-dialog-actions>